import React from 'react';
import { AIHero } from './AIHero';
import { AICapabilities } from './AICapabilities';
import { AIUseCases } from './AIUseCases';
import { AICTA } from './AICTA';
export function AIAutomation() {
  return <div className="min-h-screen w-full bg-white" data-id="element-190">
      <AIHero data-id="element-191" />
      <AICapabilities data-id="element-192" />
      <AIUseCases data-id="element-193" />
      <AICTA data-id="element-194" />
    </div>;
}